import {
  getFeatureSettings,
  isLauncherVisible,
  setFeatureEnabled,
  setLauncherVisible,
  XTgFeature
} from './config';

const labels: Record<XTgFeature, {title: string, description: string}> = {
  download: {title: '下载', description: '显示受限媒体的下载入口'},
  copy: {title: '复制', description: '允许复制受限消息内容'},
  forward: {title: '转发', description: '显示受限消息的转发入口'}
};

const settingsIcon = `
  <svg class="xtg-settings-icon" viewBox="0 0 24 24" aria-hidden="true">
    <g class="xtg-settings-icon-teeth">
      <rect x="10.25" y="1.5" width="3.5" height="5.5" rx="1"/>
      <rect x="10.25" y="17" width="3.5" height="5.5" rx="1"/>
      <rect x="17" y="10.25" width="5.5" height="3.5" rx="1"/>
      <rect x="1.5" y="10.25" width="5.5" height="3.5" rx="1"/>
      <rect x="10.25" y="1.5" width="3.5" height="5.5" rx="1" transform="rotate(45 12 12)"/>
      <rect x="10.25" y="17" width="3.5" height="5.5" rx="1" transform="rotate(45 12 12)"/>
      <rect x="17" y="10.25" width="5.5" height="3.5" rx="1" transform="rotate(45 12 12)"/>
      <rect x="1.5" y="10.25" width="5.5" height="3.5" rx="1" transform="rotate(45 12 12)"/>
    </g>
    <circle class="xtg-settings-icon-ring" cx="12" cy="12" r="6.25"/>
  </svg>`;

function createToggle(feature: XTgFeature, enabled: boolean): HTMLLabelElement {
  const label = document.createElement('label');
  label.className = 'xtg-setting-row';
  label.innerHTML = `
    <span class="xtg-setting-copy">
      <span class="xtg-setting-title">${labels[feature].title}</span>
      <span class="xtg-setting-description">${labels[feature].description}</span>
    </span>
    <input class="xtg-switch-input" type="checkbox" ${enabled ? 'checked' : ''}
      aria-label="${labels[feature].title}" />
    <span class="xtg-switch" aria-hidden="true"><span></span></span>`;

  const input = label.querySelector<HTMLInputElement>('input')!;
  input.addEventListener('change', () => setFeatureEnabled(feature, input.checked));
  return label;
}

export function mountLauncher(): void {
  if(document.querySelector('.xtg-launcher-root')) return;

  const root = document.createElement('div');
  root.className = 'xtg-launcher-root';
  root.hidden = !isLauncherVisible();

  const panel = document.createElement('section');
  panel.className = 'xtg-settings-panel';
  panel.id = 'xtg-settings-panel';
  panel.hidden = true;
  panel.setAttribute('aria-label', '下载与分享设置');

  const header = document.createElement('header');
  header.className = 'xtg-panel-header';
  header.innerHTML = '<strong>下载与分享</strong><span>受限内容操作</span>';
  panel.append(header);

  const settings = getFeatureSettings();
  (Object.keys(labels) as XTgFeature[]).forEach((feature) => {
    panel.append(createToggle(feature, settings[feature]));
  });

  const hideButton = document.createElement('button');
  hideButton.type = 'button';
  hideButton.className = 'xtg-hide-launcher';
  hideButton.textContent = '隐藏右下角入口';
  hideButton.title = '隐藏后按 Alt + Shift + D 恢复';
  panel.append(hideButton);

  const launcher = document.createElement('button');
  launcher.type = 'button';
  launcher.className = 'xtg-launcher-button';
  launcher.innerHTML = settingsIcon;
  launcher.setAttribute('aria-label', '打开下载与分享设置');
  launcher.setAttribute('aria-controls', panel.id);
  launcher.setAttribute('aria-expanded', 'false');

  const setOpen = (open: boolean) => {
    panel.hidden = !open;
    launcher.setAttribute('aria-expanded', String(open));
    root.classList.toggle('is-open', open);
    if(open) panel.querySelector<HTMLInputElement>('input')?.focus();
  };

  launcher.addEventListener('click', () => setOpen(panel.hidden === true));
  hideButton.addEventListener('click', () => {
    setOpen(false);
    setLauncherVisible(false);
  });
  document.addEventListener('pointerdown', (event) => {
    if(!panel.hidden && !root.contains(event.target as Node)) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if(event.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      launcher.focus();
    }
    if(event.altKey && event.shiftKey && event.key.toLowerCase() === 'd') {
      setLauncherVisible(true);
      launcher.focus();
    }
  });
  window.addEventListener('x-tg-download:launcher', ((event: CustomEvent<{visible: boolean}>) => {
    root.hidden = !event.detail.visible;
    if(!event.detail.visible) setOpen(false);
  }) as EventListener);

  root.append(panel, launcher);
  document.body.append(root);
}
